module.exports = __webpack_public_path__ + "static/media/theme_3.6e09e20f.jpg";